<template>
  <div class="page-content conmon-top customer-analyse">
    <div class="base-input ovf-hd"
         style="margin-bottom: 10px;">
      <el-row class="search-title">
        <el-col style="width: 300px"
                class="search-nav-left">
          <i class="el-icon-search analyse-edit-name-i"
             style="font-weight: bold;">
          </i>
          <span :title="editSingleNameShow"
                v-if="editId !== undefined"
                v-show="showSingleName === false"
                class="order-list-search-span analyse-edit-name">{{ editSingleNameShow }}</span>
          <el-input :maxlength="50"
                    v-show="showSingleName"
                    class="stockInput"
                    type="text"
                    v-model="editSingleName"
                    auto-complete="off"
                    placeholder="">
          </el-input>
          <img v-show="editId !== undefined &&
            showSingleName === false"
               tyle="cursor: pointer;width: 14px;height: 14px;margin-top: 17px;margin-left: 10px"
               src="../../assets/images/icn-binaji.png"
               class="analyse-edit-name-btn"
               @click="openEditName" />
          <i @click="saveSingleNameOnly"
             v-show="showSingleName"
             class="el-icon-circle-check-outline"
             style="color: #1980FF!important;font-size: 16px!important;cursor: pointer;margin-left: 0">
          </i>
          <span v-if="editId === undefined"
                class="order-list-search-span">分析条件</span>
        </el-col>
        <el-col style="width: calc(100% - 300px);"
                class="search-nav-right">
          <el-button class="search-open-close"
                     type="text"
                     @click="hide =! hide"
                     v-show="hide">
            {{ hide? '收起查询':'展开查询' }}
          </el-button>
          <el-button class="search-open-close"
                     type="text"
                     @click="hide =! hide"
                     v-show="!hide">
            {{ hide? '收起查询':'展开查询' }}
          </el-button>
          <i v-if="hide === true"
             class="el-icon-arrow-up search-open-close-i" @click="hide=!hide">
          </i>
          <i v-if="hide === false"
             class="el-icon-arrow-down search-open-close-i" @click="hide=!hide">
          </i>
          <el-button v-if="isAdd === 'true'"
                     class="search-btn-new btn-right"
                     type="primary"
                     size="small"
                     @click="backAction">
            返回
          </el-button>
          <el-button class="search-btn-new list-btn-right"
                     style="margin-right: 12px;"
                     v-if="editId !== undefined&&butsObj.save_as"
                     type="primary"
                     size="small"
                     @click="otherSave">
            另存为
          </el-button>
          <el-button class="search-btn-new list-btn-right"
                     style="margin-right: 12px;"
                     v-if="editId !== undefined&&butsObj.save"
                     type="primary"
                     size="small"
                     @click="editSave">
            保存
          </el-button>
          <el-button class="search-btn-new"
                     style="margin-right: 12px;"
                     v-if="editId === undefined&&butsObj.save"
                     type="primary"
                     size="small"
                     @click="openSave">
            保存
          </el-button>
          <el-button class="search-btn-new"
                     style="margin-right: 12px;"
                     type="primary"
                     size="small"
                     @click="startSearch">查询</el-button>
        </el-col>
      </el-row>
      <el-collapse-transition>
        <div v-show="hide"
             class="search-flod-content common-search-formtype"
             style="padding: 0 0 4px 0;border: none">
          <el-form :inline="true"
                   :model="formInline"
                   class="search-content-item  drs-analyse-item"
                   label-width="85px">
            <el-row style="padding-top: 7px">
              <el-form-item label="受众类型：">
                <el-select @change="modelIdChange"
                           filterable
                           v-model="formInline.modelId"
                           placeholder="受众类型："
                           class="customer-manage-search-item analyse-people"  @visible-change="visibleChangeOne" @focus="focusWayOne" ref="selectOne">
                  <el-option v-for="item in audiencesModelOptions"
                             :key="item.id"
                             :label="item.name"
                             :value="item.id">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-row>
            <el-row style="padding-top: 7px">
              <el-form-item label="分析人群：">
                <el-select filterable
                           v-model="formInline.analyse_people"
                           placeholder="分析人群"
                           class="customer-manage-search-item analyse-people"
                           @visible-change="visibleChangeOne" @focus="focusWayOne" ref="selectOne">
                  <el-option v-for="item in analysePeopleList"
                             :key="item.id"
                             :label="item.name"
                             :value="item.id">
                  </el-option>
                </el-select>
                <span @click="openDialog">
                  <i class="iconfont icon-shaixuan analyse-search-icon"></i>
                  <div class="op-link"
                       style="margin: 0;font-size: 14px">{{ filterName }}</div>
                </span>
              </el-form-item>
            </el-row>
            <!--分析人群条件显示区域-->
            <el-row class="analyse-search-show"
                    v-show="is_show_analyse_show">
              <div class="search-show-content"
                   style="clear: both">
                <!--左侧总的相对关系-->
                <div class="search-show-allRelationship"
                     style="clear: both">
                  <span class="left-allrelationship-content"
                        style="clear: both"
                        v-if="realAllTerms.termsGroup.length > 1">
                    <span class="big-term-relationship-and big-term-relationship"
                          v-if="realAllTerms.allRelationship === 'and' && realAllTerms.termsGroup.length > 1">且</span>
                    <span class="big-term-relationship-or big-term-relationship"
                          v-if="realAllTerms.allRelationship === 'or' && realAllTerms.termsGroup.length > 1">或</span>
                  </span>
                </div>
                <!--右侧条件组-->
                <div class="search-show-termsGroup">
                  <!--大的条件-->
                  <div v-for="(item, index) in realAllTerms.termsGroup"
                       :key="index"
                       class="big-term-show">
                    <!--小的条件-->
                    <div v-for="(one, i) in item.terms"
                         :key="i"
                         class="small-term-show">
                      <!--第一级-->
                      <span v-if="one.attr === 'attr'"
                            class="term-key-color">
                        受众属性-
                        <!--第二级-->
                        <span v-if="one.attr_label">{{ one.attr_label }}:</span>
                        <!--相对关系-->
                        <span v-if="one.relationship === 'equal'"
                              class="term-val-color">
                          [等于</span>
                        <span>
                          <span v-if="one.type === 'datePicker' ||
                        one.type === 'dateTimePicker'">
                            <span v-if="one.relationship === 'lt'"
                                  class="term-val-color">
                              [早于
                            </span>
                            <span v-if="one.relationship === 'gt'"
                                  class="term-val-color">
                              [晚于
                            </span>
                          </span>
                          <span v-else>
                            <span v-if="one.relationship === 'lt'"
                                  class="term-val-color">[小于
                            </span>
                            <span v-if="one.relationship === 'gt'"
                                  class="term-val-color">[大于
                            </span>
                          </span>
                        </span>
                        <span v-if="one.relationship === 'not_equal'"
                              class="term-val-color">[不等于</span>
                        <span v-if="one.relationship === 'gtele'"
                              class="term-val-color">[区间</span>
                        <span v-if="one.relationship === 'contain'"
                              class="term-val-color">[包含</span>
                        <span v-if="one.relationship === 'not_contain'"
                              class="term-val-color">
                          [不包含
                        </span>
                        <span v-if="one.relationship === 'empty'"
                              class="term-val-color">
                          为空
                        </span>
                        <span v-if="one.relationship === 'not_empty'"
                              class="term-val-color">[不为空
                        </span>
                        <!--值-->
                        <!-- 当前等级 -->
                        <span v-if="one.type === 'dict' && one.selectedOptions[1].split('@')[0] === 'stage_id'">
                          {{ stageUse[one.value] }}]
                        </span>
                        <span v-if="
                          one.selectedOptions[1].split('@')[0] !== 'stage_id' &&
                          one.selectedOptions[1].split('@')[0] !== 'source_id' &&
                          one.selectedOptions[1].split('@')[1] !== 'datePicker' &&
                          one.selectedOptions[1].split('@')[1] !== 'number' &&
                          one.selectedOptions[1].split('@')[1] !== 'addressPicker' &&
                          one.selectedOptions[1].split('@')[1] !== 'dateTimePicker' &&
                          one.value"
                              class="term-val-color">{{ one.value }}]
                        </span>
                        <span v-if="one.type === 'number'"
                              class="term-val-color">
                          <span v-if="one.relationship === 'gtele'">
                            [{{ one.startValue }}至{{ one.endValue }}]]</span>
                          <span v-else>{{ one.value }}]</span>
                        </span>
                        <span v-if="
                          one.selectedOptions[1].split('@')[0] !== 'addressPicker' &&
                          one.selectedOptions[1].split('@')[0] === 'source_id' &&
                          one.selectedOptions[1].split('@')[1] !== 'datePicker'"
                              class="term-val-color">
                          {{ sourceUse[one.value] }}]
                        </span>
                        <span v-if="one.selectedOptions[1].split('@')[1] === 'datePicker'"
                              class="term-val-color">
                          <span v-if="one.relationship === 'gtele'">[{{ one.startValue }}至{{ one.endValue }}]]</span>
                          <span v-else>{{ one.value }}]</span>
                        </span>
                        <span v-if="
                          one.selectedOptions[1].split('@')[1] === 'dateTimePicker'"
                              class="term-val-color">
                          <span v-if="one.relationship === 'gtele'">
                            [{{ one.startValue }}至{{ one.endValue }}]]
                          </span>
                          <span v-else>{{ one.value }}]</span>
                        </span>
                        <span v-if="one.selectedOptions[1].split('@')[1] === 'addressPicker' &&
                        one.relationship !== 'empty' &&
                        one.relationship !== 'not_empty'"
                              class="term-val-color">
                          {{ CodeToText[one.value[0]] }}
                        </span>
                        <span v-if="
                          one.selectedOptions[1].split('@')[1] === 'addressPicker' &&
                          one.relationship !== 'empty' &&
                          one.relationship !== 'not_empty'"
                              class="term-val-color">
                          {{ CodeToText[one.value[1]] }}
                        </span>
                        <span v-if="
                        one.selectedOptions[1].split('@')[1] === 'addressPicker' &&
                        one.relationship !== 'empty' &&
                        one.relationship !== 'not_empty'"
                              class="term-val-color">
                          {{ CodeToText[one.value[2]] }}]
                        </span>
                      </span>
                      <span v-if="one.attr === 'group'"
                            class="term-key-color">
                        {{ one.attr_label }}:
                        <span class="term-val-color">
                          <span>[{{ divideGroupShow[one.value[1]] }}]</span>
                        </span>
                      </span>
                      <span v-if="one.attr === 'aud_portary'"
                            class="term-key-color">
                        {{ one.attr_label }}:
                        <span v-if="one.relationship === 'contain'"
                              class="term-val-color">[包含</span>
                        <span v-if="one.relationship === 'not_contain'"
                              class="term-val-color">[不包含</span>
                        <span v-if="one.relationship === 'empty'"
                              class="term-val-color">为空
                        </span>
                        <span v-if="one.relationship === 'not_empty'"
                              class="term-val-color">[不为空
                        </span>
                        <span class="term-val-color">
                          {{ one.value }}]
                        </span>
                      </span>
                      <span v-if="one.attr === 'wechat_open_id'"
                            class="term-key-color">
                        {{ one.attr_label }}:
                        <span v-if="one.relationship === 'equal'"
                              class="term-val-color">[等于</span>
                        <span v-if="one.relationship === 'not_equal'"
                              class="term-val-color">[不等于</span>
                        <span v-if="one.relationship === 'empty'"
                              class="term-val-color">为空
                        </span>
                        <span v-if="one.relationship === 'not_empty'"
                              class="term-val-color">[不为空
                        </span>
                        <span class="term-val-color">
                          {{ one.value }}]
                        </span>
                      </span>
                      <span v-if="one.attr === 'event'"
                            class="term-key-color">
                        受众事件- {{ events[one.selectedOptions[2]] }}
                        <br v-if="one.eventCheckbox1 === true" />
                        <!--限制条件-->
                        <!--起止时间-->
                        <span v-if="one.eventCheckbox1 === true">
                          <span>
                            <span v-if="one.eventCheckbox1 === true && one.eventCheckbox2 === true">├─</span>
                            <span v-if="one.eventCheckbox1 === true && one.eventCheckbox2 === false">└─</span> 起止时间：
                            <span class="term-val-color"
                                  v-if="one.eventSearchDateSelect !== 'cstm'">{{ one.start_end_time }}</span>
                            <span class="term-val-color"
                                  v-if="one.eventSearchDateSelect === 'cstm'">{{ one.start_end_time }}: {{ new Date(one.eventSearchDateSelectStart).getTime() / 1000 | formatDate }}至{{ new Date(one.eventSearchDateSelectEnd).getTime() / 1000 | formatDate }}</span>
                          </span>
                        </span>
                        <br v-if="one.eventCheckbox1 === true && one.eventCheckbox2 === true" />
                        <!--发生次数-->
                        <span v-if="one.eventCheckbox2 === true">
                          └─ 发生次数：
                          <span v-if="one.eventSearchTimesSelect === 'equal'"
                                class="term-val-color">
                            [等于
                          </span>
                          <span v-if="one.eventSearchTimesSelect === 'gt'"
                                class="term-val-color">[大于</span>
                          <span v-if="one.eventSearchTimesSelect === 'lt'"
                                class="term-val-color">[小于</span>
                          <span v-if="one.eventSearchTimesSelect === 'gte'"
                                class="term-val-color">[大于等于</span>
                          <span v-if="one.eventSearchTimesSelect === 'lte'"
                                class="term-val-color">[小于等于</span>
                          <span v-if="one.eventSearchTimesSelect === 'gtele'"
                                class="term-val-color">[区间</span>
                          <span v-if="one.eventSearchTimesSelect !== 'gtele'"
                                class="term-val-color">{{ one.happenedTimes }}]</span>
                          <span v-if="one.eventSearchTimesSelect === 'gtele'"
                                class="term-val-color">{{ one.happenedTimes_from }}至{{ one.happenedTimes_to }}]</span>
                        </span>
                      </span>
                      <span v-if="one.attr === 'follow_public'"
                            class="term-key-color">
                        关注公众号-{{ one.attr_label }}
                        <span class="term-val-color">[{{ wechatUse[one.value] }}]</span>
                      </span>
                      <span v-if="one.attr === 'number'"
                            class="term-key-color">
                        <span class="term-val-color">[{{ wechatUse[one.value] }}]</span>
                      </span>
                      <span v-if="one.attr === 'customer_kpi'"
                            class="term-key-color">
                        受众关键指标-{{ one.attr_label }}
                        <span v-if="one.relationship === 'equal'"
                              class="term-val-color">
                          [等于
                        </span>
                        <span v-if="one.relationship === 'not_equal'"
                              class="term-val-color">
                          [不等于
                        </span>
                        <span v-if="one.relationship === 'gt'"
                              class="term-val-color">
                          [大于
                        </span>
                        <span v-if="one.relationship === 'lt'"
                              class="term-val-color">
                          [小于
                        </span>
                        <span v-if="one.relationship === 'gte'"
                              class="term-val-color">
                          [大于等于
                        </span>
                        <span v-if="one.relationship === 'lte'"
                              class="term-val-color">
                          [小于等于
                        </span>
                        <span v-if="one.relationship === 'gtele'"
                              class="term-val-color">
                          [区间
                        </span>
                        <span v-if="one.relationship === 'empty'"
                              class="term-val-color">
                          为空
                        </span>
                        <span v-if="one.relationship === 'not_empty'"
                              class="term-val-color">
                          不为空
                        </span>
                        <span v-if="one.relationship !== 'gtele'"
                              class="term-val-color">
                          {{ one.value }}]
                        </span>
                        <span v-if="one.relationship === 'gtele'"
                              class="term-val-color">
                          {{ one.startValue }}至{{ one.endValue }}]
                        </span>
                      </span>
                      <!--小的相对关系-->
                      <span class="samll-relationship-and"
                            v-if="item.inOperator === 'and' && i !== (item.terms.length - 1)">且</span>
                      <span class="samll-relationship-or"
                            v-if="item.inOperator === 'or' && i !== (item.terms.length - 1)">或</span>
                    </div>
                  </div>
                </div>
              </div>
            </el-row>
            <!--指标-->
            <el-row style="margin-bottom: 8px;margin-top: 10px">
              <el-form-item label="分析指标：">
                <div v-for="(one, i) in analyseQuotaData"
                     :key="i"
                     style="float: left">
                  <!--级联选择器-->
                  <el-cascader :options="analyseQuotaOptions"
                               v-model="one.analyseQuota"
                               filterable
                               ref="cascader"
                               class="first-attr behavior-dimension">
                  </el-cascader>
                  <div class="remove-btn-quota"
                       @click="removeQuotaItem(one,i)"
                       v-if="analyseQuotaData.length > 1"
                       style="float: right;margin: 0 20px 0 10px;cursor: pointer;color: #ccc;font-size: 15px">
                    <i class="el-icon-error"
                       title="删除当前条件"></i>
                  </div>
                </div>
                <div @click="addAnalyseQuota"
                     style="margin: 1px 0 0 12px;height: 34px"
                     class="add-quota-btn"
                     v-if="analyseQuotaData.length < 4">
                  <i class="el-icon-plus"
                     style="color: #1890ff;"></i>
                  <div class="op-link"
                       style="margin: 0;font-size: 14px">添加指标</div>
                </div>
              </el-form-item>
            </el-row>
            <!--维度-->
            <el-row style="padding-bottom: 34px">
              <el-form-item class="search-content-item customer-analyse-input zy-analyse-item"
                            label="分析维度：">
                <div v-for="(two, j) in analyseDimensionData"
                     :key="j"
                     style="float: left">
                  <!--级联选择器-->
                  <el-cascader :options="analyseDimensionOptions"
                               v-model="two.dimension"
                               @change="changeDimension($event, j)"
                               filterable
                               class="first-attr analyse-people customer-dimension">
                  </el-cascader>
                  <div class="remove-btn-quota"
                       @click="removeDimensionItem(two, j)"
                       v-if="analyseDimensionData.length > 1"
                       style="float: right;margin: 0 20px 0 10px;cursor: pointer">
                    <i class="el-icon-error"
                       title="删除当前条件"
                       style="color: #ccc;font-size: 15px"></i>
                  </div>
                  <div v-show="two.showSetValue"
                       class="setting-btn-quota"
                       title="设置数值区间功能"
                       @click="handleOpenSeetingVisible(j)">
                    <img src="../../assets/images/setting-icon.png" />
                  </div>
                  <!-- 设置数值区间的弹窗 -->
                  <SettingValueDialog :sectionFormLine="two.sectionFormLine"
                                      :visible="two.showSetValueDialog"
                                      @handleSeetingVisible="handleSeetingVisible(j)"
                                      @handleSectionSubmit="handleSectionSubmit($event,j)"></SettingValueDialog>

                </div>
                <div @click="addAnalyseDimension"
                     class="add-quota-btn"
                     v-if="analyseDimensionData.length <= 3">
                  <i class="el-icon-plus"
                     style="color: #1890ff;"></i>
                  <div class="op-link"
                       style="margin: 0;font-size: 14px">添加维度</div>
                </div>
              </el-form-item>

            </el-row>
          </el-form>
        </div>
      </el-collapse-transition>
    </div>
    <!--结果title-->
    <el-row v-show="showResult"
            class="search-title common-table-top"
            style="border-bottom: none;padding-right: 0">
      <el-col :span="4"
              style="text-align: left;">
        <i class="el-icon-document"
           style="font-weight: bold;"></i>
        <span class="order-list-search-span">分析结果</span>
      </el-col>
      <el-col :span="20"
              class="text-align-right">
        <el-button v-if="showType.table.is_have === true&&butsObj.export"
                   type="primary"
                   @click="exporeAction"
                   class="add-btn"
                   style="float: right;margin-right: 32px">导出</el-button>
        <!--表格-->
        <i v-if="showType.table.is_have === false"
           style="color: #CDCDCD!important;margin-right: 12px"
           class="analyse-res-icon iconfont icon-wenbenjieguo-1"></i>
        <i v-if="showType.table.is_have === true"
           @click="chooseTable"
           :class="showType.table.choosed ? 'icon-wenbenjieguo-' : 'icon-wenbenjieguo'"
           class="analyse-res-icon iconfont"
           style="cursor: pointer;margin-right: 12px"></i>
        <!--饼-->
        <i v-if="showType.pie.is_have === false"
           style="color: #CDCDCD!important;"
           class="analyse-res-icon iconfont icon-bingzhuangtu-1"></i>
        <i v-if="showType.pie.is_have === true"
           @click="choosePie"
           :class="showType.pie.choosed ? 'icon-bingzhuangtu-' : 'icon-bingzhuangtu'"
           class="analyse-res-icon iconfont"
           style="cursor: pointer"></i>
        <!--线-->
        <i v-if="showType.line.is_have === false"
           style="color: #CDCDCD!important;"
           class="analyse-res-icon iconfont icon-zhexiantu-"></i>
        <i v-if="showType.line.is_have === true"
           @click="chooseLine"
           :class="showType.line.choosed ? 'icon-zhexiantu' : 'icon-zhexiantu-1'"
           class="analyse-res-icon iconfont"
           style="cursor: pointer"></i>
        <!--柱-->
        <i v-if="showType.zhu.is_have === false"
           style="color: #CDCDCD!important;"
           class="analyse-res-icon iconfont icon-zhuzhuangjieguo-"></i>
        <i v-if="showType.zhu.is_have === true"
           @click="chooseZhu"
           :class="showType.zhu.choosed ? 'icon-zhuzhuangjieguo' : 'icon-zhuzhuangjieguo-1'"
           class="iconfont analyse-res-icon"
           style="cursor: pointer"></i>
        <!--数字-->
        <i v-if="showType.num.is_have === false"
           style="color: #CDCDCD!important;"
           class="analyse-res-icon iconfont icon-shuzijieguo-1"></i>
        <i v-if="showType.num.is_have === true"
           class="iconfont analyse-res-icon"
           @click="chooseNum"
           :class="showType.num.choosed ? 'icon-shuzijieguo-' : 'icon-shuzijieguo'"
           style="cursor: pointer"></i>
      </el-col>
    </el-row>
    <!--实际结果展示-->
    <el-row class="import-data-title">
      <a-locale-provider :locale="zhCN">
        <a-table :pagination="{
            total: totalCount,
            defaultCurrent: page,
            pageSize: limit,
            showQuickJumper: true,
            showSizeChanger: false,
            showTotal: function (total) { // 设置显示一共几条数据
              return '共 ' + total + ' 条数据'
            }
          }"
                 style="width: calc(100% - 48px);margin: 0 auto"
                 v-if="showType.table.is_have === true && showType.table.choosed === true"
                 :columns="columns"
                 :dataSource="tableData">
        </a-table>
      </a-locale-provider>
      <!--<div class="table-foot" v-show="showType.table.is_have === true && showType.table.choosed === true">-->
      <!--<a-locale-provider :locale="zhCN">-->
      <!--<a-pagination :pageSize.sync="limit" :showTotal="totals" showQuickJumper :defaultCurrent="1" class="ant-paginnation" :total="totalCount" @change="onChange" />-->
      <!--</a-locale-provider>-->
      <!--&lt;!&ndash;<el-pagination&ndash;&gt;-->
      <!--&lt;!&ndash;class="table-foot-pagination"&ndash;&gt;-->
      <!--&lt;!&ndash;background&ndash;&gt;-->
      <!--&lt;!&ndash;@size-change="handleSizeChange"&ndash;&gt;-->
      <!--&lt;!&ndash;@current-change="handleCurrentChange"&ndash;&gt;-->
      <!--&lt;!&ndash;:page-size="limit"&ndash;&gt;-->
      <!--&lt;!&ndash;layout="total, prev, pager, next, jumper"&ndash;&gt;-->
      <!--&lt;!&ndash;:total="totalCount">&ndash;&gt;-->
      <!--&lt;!&ndash;</el-pagination>&ndash;&gt;-->
      <!--</div>-->
      <!--数字-->
      <div class="result-number-wrap"
           v-show="showType.num.is_have === true && showType.num.choosed === true">
        <span>{{ resultNum }}</span>
      </div>
      <!--柱状图-->
      <div class="chart-content"
           v-show="showType.zhu.is_have === true && showType.zhu.choosed === true">
        <div id="chartZhu"
             class="chart1"></div>
      </div>
      <!--折线图-->
      <div class="chart-content"
           v-show="showType.line.is_have === true && showType.line.choosed === true">
        <div id="chartLine"
             class="chart1"></div>
      </div>
      <!--饼图-->
      <div class="chart-content"
           v-show="showType.pie.is_have === true && showType.pie.choosed === true">
        <div id="chartPie"
             class="chart1"></div>
      </div>
    </el-row>
    <!--筛选条件弹窗-->
    <el-dialog class="cellDialog analyse-dialog"
               title="人群筛选条件"
               :visible.sync="searchDialog"
               width="1090px">
      <higher-search-audiences :modelId="formInline.modelId"
                               class="common-search-formtype customer-manage-higher-search group-item-style high-search-cascader analyse-high-search"
                               :forSonTerms="forSonTerms"
                               :isAnalyse="isAnalyse"
                               v-bind:allRelationship="allRelationship"
                               @change="getAllTerms"
                               style="margin-top: 10px">
      </higher-search-audiences>
      <div slot="footer"
           class="dialog-footer"
           style="margin-top: 10px">
        <el-button class="dialog-cancel-btn"
                   style="margin-left: 20px"
                   @click="searchDialog = false">取 消</el-button>
        <el-button class="dialog-confirm-btn"
                   type="primary"
                   @click="confirmSearchTerms"
                   style="margin-right: 32px">确 定</el-button>
      </div>
    </el-dialog>
    <!--保存单图弹窗-->
    <el-dialog class="cellDialog base-dialog saveSingle"
               title="保存单图"
               :visible.sync="saveSingleDialog"
               width="520px">
      <el-form ref="addForm"
               :model="saveForm">
        <el-form-item label="单图名称:"
                      label-width="110">
          <el-input :maxlength="50"
                    class="stockInput"
                    type="text"
                    v-model="saveForm.name"
                    auto-complete="off"
                    placeholder="输入单图名称"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer"
           class="dialog-footer"
           style="margin-top: 10px">
        <el-button class="dialog-cancel-btn"
                   @click="saveSingleDialog = false"
                   style="margin-left: 20px">取 消</el-button>
        <el-button class="dialog-confirm-btn"
                   type="primary"
                   style="margin-right: 32px"
                   @click="confirmSave">确 定</el-button>
      </div>
    </el-dialog>
    <!--另存为单图弹窗-->
    <el-dialog class="cellDialog base-dialog saveSingle"
               title="另存为单图"
               :visible.sync="otherSaveSingleDialog"
               width="520px">
      <el-form ref="addForm"
               :model="otherSaveForm">
        <el-form-item label="单图名称:"
                      label-width="110">
          <el-input :maxlength="50"
                    class="stockInput"
                    type="text"
                    v-model="otherSaveForm.name"
                    auto-complete="off"
                    placeholder="输入单图名称"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer"
           class="dialog-footer"
           style="margin-top: 10px">
        <el-button class="dialog-cancel-btn"
                   @click="otherSaveSingleDialog = false"
                   style="margin-left: 20px">取 消</el-button>
        <el-button class="dialog-confirm-btn"
                   type="primary"
                   style="margin-right: 32px"
                   @click="confirmOtherSave">确 定</el-button>
      </div>
    </el-dialog>

  </div>
</template>
<script>
import {
  getCustomerStage, getSourceData,
  getCustomerAttributeList, exportMemberInterestOrder,
  getBigWheelList, getWechatPublicListForNode,
  getWePagesListForNode, getMessageListForNode,
} from '@/api/customer.js'
import { customerAnalyseSearch, analyseSaveSingle, customerAnalyseSingleEdit, addSingleChartToDashBoard, updateDashBoard, butonsList, getMenId } from '@/api/analyse.js'
import { getCusTypes, getAudGroupGroupList, getCusAttrList, getAudGroupList, getCusEventList, getAudGroupAndDimension, getCusStageList, getCustomerSources } from '@/api/set.js'
import HigherSearchAudiences from './../common/higher-search-audiences.vue'
import { Table, LocaleProvider } from 'ant-design-vue'
import zhCN from 'ant-design-vue/lib/locale-provider/zh_CN'
import { regionDataPlus, CodeToText, TextToCode } from 'element-china-area-data'
import { judgeIsEmpty } from '../../api/publicMethods'
import { NEGATIVE_INFINITY, INFINITY, ANALYSE_DIMENSION_DATA_INIT, ATTR_LIST, ANALYSE_OPTIONS_LIST, ANALYSE_DIMENSION_OPTIONS_FUN, ANALYSE_DIMENSION_DATA_FUN, SECTION_LIST_INIT } from './constant'
import SettingValueDialog from './components/SettingValueDialog.vue'
export default {
  name: 'customerAnalyse',
  data () {
    return {
      inputFlagOne: null,
      showTypeCont: 'table',
      isAnalyse: true,
      audiencesModelOptions: [], // 受众类型
      dashBoardId: window.localStorage.getItem('dashBoardId'),
      myStorage: window.localStorage,
      allRelationship: 'and',
      filterName: '选择人群筛选条件',
      realAllTerms: {
        allRelationship: 'and',
        termsGroup: [
          {
            inOperator: 'and',
            terms: [
              {
                secAttr: '',
                startValue: '',
                endValue: '',
                attr_label: '',
                attr: 'attr',
                relationship: '',
                relationOptions: [
                  {
                    value: 'equal',
                    label: '等于'
                  }, {
                    value: 'not_equal',
                    label: '不等于'
                  }, {
                    value: 'contain',
                    label: '包含'
                  }, {
                    value: 'not_contain',
                    label: '不包含'
                  }, {
                    value: 'empty',
                    label: '为空'
                  },
                  {
                    value: 'not_empty',
                    label: '不为空'
                  }
                ],
                gridNum: 3,
                visible2: false,
                start_end_time: '昨日',
                happenedTimes: '',
                happenedTimes_from: '',
                happenedTimes_to: '',
                gtele_start: '',
                gtele_end: '',
                value: null,
                qrcode: null,
                eventCheckbox1: false, // 选择受众事件的checkbox
                eventCheckbox2: false,
                eventCheckbox3: false,
                eventSearchDateSelect: 'yesterday', // 选择受众事件选中起止时间选择框
                eventSearchDateSelectStart: '',
                eventSearchDateSelectEnd: '',
                eventSearchTimesSelect: '', // 选择受众事件选中发生次数选择框
                eventAttributeOptions: [ // 选择受众事件选中事件属性
                  {
                    attributeSelect: '',
                    attributeRelation: '',
                    attributeValue: ''
                  }
                ],
                selectedOptions: ['attr', '']
              }
            ]
          }
        ]
      },
      activityUse: [],
      smsUse: [],
      stageUse: {},
      wepageUse: [],
      sourceUse: {},
      wechatUse: [],
      events: {},
      activities: [],
      sms: [],
      wepage: [],
      wechatPublic: [],
      excelData: [],
      groupShow: {},
      divideGroupShow: {},
      is_show_analyse_show: false,
      CodeToText: CodeToText,
      xNames: '',
      yNames: '',
      barWidth: '',
      otherSaveSingleDialog: false,
      showSingleName: false,
      editSingleName: '',
      editSingleNameShow: '',
      queryJson: '',
      editId: '',
      searchTermsAllLocal: {},
      saveForm: {
        name: ''
      },
      otherSaveForm: {
        name: ''
      },
      saveSingleDialog: false,
      zhCN,
      xNamePie: '',
      chartDataYPie: [],
      chartDataYBar: [],
      chartDataY: [],
      chartDataX: [],
      showResult: false,
      columns: [
        {
          title: 'Name',
          dataIndex: 'name',
          key: 'name'
        }, {
          title: 'Age',
          dataIndex: 'age',
          key: 'age',
          width: '12%'
        }, {
          title: 'Address',
          dataIndex: 'address',
          width: '30%',
          key: 'address'
        }
      ],
      chartZhuOneDataArray: [],
      myChartZhu: null,
      myChartLine: null,
      myChartPie: null,
      showType: {
        num: {
          is_have: false,
          choosed: false
        },
        table: {
          is_have: false,
          choosed: false
        },
        pie: {
          is_have: false,
          choosed: false
        },
        line: {
          is_have: false,
          choosed: false
        },
        zhu: {
          is_have: false,
          choosed: false
        }
      },
      resultNum: '',
      analyseDimensionData: ANALYSE_DIMENSION_DATA_INIT,
      analyseDimensionOptions: ANALYSE_DIMENSION_OPTIONS_FUN(),
      analyseQuotaData: [
        {
          analyseQuota: ['customer', 'peopleNum', 'sum']
        }
      ],
      analyseQuotaOptions: ANALYSE_OPTIONS_LIST,
      formInline: {
        modelId: '',
        analyse_people: '',
        order_num: '',
        create_time: '',
        vip_card: '',
        truename: '',
        consignee_name: '',
        consignee_number: '',
        status: ''
      },
      searchDialog: false,
      hide: true,
      loading: true,
      tableData: [
        {
          key: 1,
          name: 'John Brown sr.',
          age: 60,
          address: 'New York No. 1 Lake Park',
          children: [{
            key: 11,
            name: 'John Brown',
            age: 42,
            address: 'New York No. 2 Lake Park'
          }, {
            key: 12,
            name: 'John Brown jr.',
            age: 30,
            address: 'New York No. 3 Lake Park',
            children: [{
              key: 121,
              name: 'Jimmy Brown',
              age: 16,
              address: 'New York No. 3 Lake Park'
            }]
          }, {
            key: 13,
            name: 'Jim Green sr.',
            age: 72,
            address: 'London No. 1 Lake Park',
            children: [{
              key: 131,
              name: 'Jim Green',
              age: 42,
              address: 'London No. 2 Lake Park',
              children: [{
                key: 1311,
                name: 'Jim Green jr.',
                age: 25,
                address: 'London No. 3 Lake Park'
              }, {
                key: 1312,
                name: 'Jimmy Green sr.',
                age: 18,
                address: 'London No. 4 Lake Park'
              }]
            }]
          }]
        }, {
          key: 2,
          name: 'Joe Black',
          age: 32,
          address: 'Sidney No. 1 Lake Park'
        }
      ],
      page: 1,
      limit: 10,
      search: {},
      allTerms: {
        allRelationship: 'and',
        termsGroup: [
          {
            inOperator: 'and',
            terms: [
              {
                startValue: '',
                endValue: '',
                attr_label: '',
                qrcodeUse: [],
                attr: 'attr',
                relationship: '',
                relationOptions: [
                  {
                    value: 'equal',
                    label: '等于'
                  }, {
                    value: 'not_equal',
                    label: '不等于'
                  }, {
                    value: 'contain',
                    label: '包含'
                  }, {
                    value: 'not_contain',
                    label: '不包含'
                  }, {
                    value: 'empty',
                    label: '为空'
                  },
                  {
                    value: 'not_empty',
                    label: '不为空'
                  }
                ],
                gridNum: 3,
                visible2: false,
                start_end_time: '昨日',
                happenedTimes: '',
                happenedTimes_from: '',
                happenedTimes_to: '',
                gtele_start: '',
                gtele_end: '',
                value: null,
                qrcode: null,
                eventCheckbox1: false, // 选择受众事件的checkbox
                eventCheckbox2: false,
                eventCheckbox3: false,
                eventSearchDateSelect: 'yesterday', // 选择受众事件选中起止时间选择框
                eventSearchDateSelectStart: '',
                eventSearchDateSelectEnd: '',
                eventSearchTimesSelect: '', // 选择受众事件选中发生次数选择框
                eventAttributeOptions: [ // 选择受众事件选中事件属性
                  {
                    attributeSelect: '',
                    attributeRelation: '',
                    attributeValue: ''
                  }
                ],
                selectedOptions: ['attr', 'realname@input']
              }
            ]
          }
        ]
      },
      totalCount: 0,
      analysePeopleList: [],
      analysePeopleListOne: [],
      forSonTerms: [
        {
          inOperator: 'and',
          terms: [
            {
              attr: 'attr',
              attr_label: '',
              relationship: '',
              relationOptions: [],
              value: null,
              option: [],
              eventAttrOptions: [
                {
                  attributeContent: '',
                  relationOptions: [],
                  sources: [],
                  eventAttrValueOptions: [],
                  attributeRelation: '',
                  attr_type: '',
                  attrValTimeStart: '',
                  attrValTimeEnd: '',
                  attributeValueStart: '',
                  attributeValueEnd: '',
                  attributeValue: ''
                }
              ],
              selectedOptions: ['attr', '']
            }
          ]
        }
      ],
      allRelationshipSearch: '',
      memberLevelList: {},
      isAdd: window.localStorage.getItem('borderDetailsIsAdd'),
      butsObj: { // button按钮列表
        save: false,
        export: false,
        save_as: false
      }
    }
  },
  components: {
    'higher-search-audiences': HigherSearchAudiences,
    ATable: Table,
    ALocaleProvider: LocaleProvider,
    SettingValueDialog
  },
  methods: {
    focusWayOne () {
      if (this.inputFlagOne) {
        this.$refs['selectOne'].blur()
      }
    },
    visibleChangeOne (val) {
      setTimeout(()=> {
        this.inputFlagOne = val
      },0)
    },
    //设置区间值提交
    handleSectionSubmit (list, index) {
      // 关闭弹窗
      this.handleSeetingVisible(index)
      this.analyseDimensionData[index].sectionFormLine.sectionList = list

    },

    // 打开弹窗
    handleOpenSeetingVisible (index) {
      this.analyseDimensionData[index].showSetValueDialog = true
    },

    // 关闭弹窗
    handleSeetingVisible (index) {
      this.analyseDimensionData[index].showSetValueDialog = false
    },
    openDialog () {
      this.searchDialog = true
    },
    loadAudGroupAndDimension () {
      getAudGroupAndDimension(this.formInline.modelId).then(res => {
        if (res.data.code === '200') {
          for (let userGroups of res.data.result.userGroups) {
            this.divideGroupShow[userGroups.id] = userGroups.name
          }
          let data = res.data.result.dimensions
          let remainData = []
          // 循环删除省市区国家以及checkbox的元素  并且radio的改为select
          for (let i in data) {
            remainData.push(data[i])
          }
          // 拼接处理获得的属性列表到本地数据
          for (let i in remainData) {
            remainData[i].value = remainData[i].identity
            remainData[i].label = remainData[i].name
          }
          this.analyseDimensionOptions[1].children = remainData
        }
      })
    },
    loadCustomerStage (modelId) {
      getCusStageList(modelId).then(res => {
        res.data.result.unshift({
          id: 0,
          name: '未知等级'
        })
        for (let item of res.data.result) {
          let id = parseInt(item.id)
          this.stageUse[id] = item.name
        }
      })
    },
    // modelid改变触发
    modelIdChange (val) {
      this.loadAudGroupList()
      this.changeCondition()
      this.loadAudGroupAndDimension()
      this.loadCustomerStage(val)
      // this.loadCusAttrList()
    },
    changeCondition () {
      this.analyseDimensionData = ANALYSE_DIMENSION_DATA_FUN()
      for (let one of this.analyseDimensionOptions) {
        if (one.children) {
          for (let item of one.children) {
            item.disabled = false
          }
        } else {
          one.disabled = false
        }
      }
      let terms = sessionStorage.getItem(this.formInline.modelId)
      console.log('terms', terms)
      if (terms) {
        this.realAllTerms = JSON.parse(terms)
        this.forSonTerms = JSON.parse(JSON.stringify(this.realAllTerms.termsGroup))
      } else {
        this.forSonTerms = [
          {
            inOperator: 'and',
            terms: [
              {
                attr: 'attr',
                secAttr: '',
                attr_label: '',
                relationship: '',
                relationOptions: [],
                value: null,
                option: [],
                eventAttrOptions: [
                  {
                    attributeContent: '',
                    relationOptions: [],
                    sources: [],
                    eventAttrValueOptions: [],
                    attributeRelation: '',
                    attr_type: '',
                    attrValTimeStart: '',
                    attrValTimeEnd: '',
                    attributeValueStart: '',
                    attributeValueEnd: '',
                    attributeValue: ''
                  }
                ],
                selectedOptions: ['attr', '']
              }
            ]
          }
        ]
      }
      this.realAllTerms.termsGroup = JSON.parse(JSON.stringify(this.forSonTerms))
    },
    // 分析人群
    loadAudGroupList () {
      getAudGroupList(this.formInline.modelId, 1, 1000, '', '').then(res => {
        this.analysePeopleList = []
        if (res.data.code === '200') {
          // 分析人群
          this.analysePeopleList.push({
            id: 0,
            name: '全部'
          })
          for (let f of res.data.result.list) {
            this.divideGroupShow[f.id] = f.name
            this.analysePeopleList.push(f)
          }
          this.formInline.analyse_people = 0
        }
      })
    },
    // 获取受众群组分组列表
    loadAudGroupGroupList () {
      getAudGroupGroupList(this.formInline.modelId, '').then(res => {
        // 处理群组
        if (res.data.code === '200') {
          // 处理之后给翻译用
          for (let i of res.data.result) {
            this.groupShow[i.id] = i.name
          }
          this.groupShow[0] = '全部'
          // 处理给分析人群
          res.data.result.unshift({
            id: '',
            name: '全部'
          })
        }
      })
    },
    // 获取受众类型
    loadCusTypes () {
      getCusTypes().then(res => {
        if (res.data.code === '200') {
          this.audiencesModelOptions = res.data.result
          this.formInline.modelId = res.data.result[0].id
          for (let ids of res.data.result) {
            sessionStorage.removeItem(ids.id)
          }
          this.loadAudGroupAndDimension()
          this.loadAudGroupList()
          this.loadCustomerStage(res.data.result[0].id)
          this.load()
          // this.loadCusAttrList()
          // this.loadAudGroupGroupList()
        }
      })
    },
    // 返回到看板详情
    backAction () {
      this.myStorage.setItem('borderDetailsIsAdd', 'false')
      router.push({ path: '/home/board-list' })
    },
    // 确定查询条件
    confirmSearchTerms () {
      // 判断是否为空
      if (!judgeIsEmpty(this.allTerms.termsGroup)) {
        return
      }
      this.searchDialog = false
      this.is_show_analyse_show = true
      this.allTerms.modelId = this.formInline.modelId
      sessionStorage.setItem(this.formInline.modelId, JSON.stringify(this.allTerms))
      this.realAllTerms = JSON.parse(JSON.stringify(this.allTerms))
      this.filterName = '修改人群筛选条件'
    },
    // 确定另存为单图
    confirmOtherSave () {
      // 处理查询条件
      let searchTermsAll = {}
      searchTermsAll.searchPeople = this.formInline.analyse_people
      // 处理高级查询传来的条件
      let termsSend = JSON.parse(JSON.stringify(this.realAllTerms))
      for (let item of termsSend.termsGroup) {
        for (let one of item.terms) {
          let str = ''
          if (one.selectedOptions.length > 0 && one.selectedOptions[0] === 'attr') {
            str = one.selectedOptions[1].split('@')[0]
          }
          if (one.selectedOptions.length > 0 && one.selectedOptions[0] === 'event') {
            str = one.selectedOptions[2]
          }
          if (one.selectedOptions.length > 0 && one.selectedOptions[0] === 'group') {
            str = one.selectedOptions[1].split('@')[0]
          }
          if (one.selectedOptions.length > 0 && one.selectedOptions[0] === 'wechat_open_id') {
            str = one.selectedOptions[1].split('@')[0]
          }
          if (one.selectedOptions.length > 0 && one.selectedOptions[0] === 'aud_portary') {
            str = 'tag'
          }
          if (one.selectedOptions.length > 0 && one.selectedOptions[0] === 'customer_kpi') {
            str = one.selectedOptions[1].split('@')[0]
          }
          // 处理生日为字符串
          if (one.selectedOptions[0] === 'attr' && one.selectedOptions[1].split('@')[1] === 'datePicker') {
            let d = new Date(one.value)
            let month = d.getMonth() + 1 < 10 ? '0' + (d.getMonth() + 1) : d.getMonth() + 1
            let day = d.getDate() < 10 ? '0' + (d.getDate()) : d.getDate()
            one.value = d.getFullYear() + '-' + month + '-' + day
          }
          let firAttr = one.selectedOptions[0]
          one.attr = firAttr
          // one.secAttr = str[0]
          // one.option = null
          // one.relationOptions = null
          // one.qrcodeUse = null
        }
      }
      searchTermsAll.search = termsSend
      // 判断指标至少有一个是有条件的
      let analyseQuotaCount = 0
      for (let one of this.analyseQuotaData) {
        if (one.analyseQuota.length > 0) {
          analyseQuotaCount = analyseQuotaCount + 1
        }
      }
      if (analyseQuotaCount === 0) {
        _g.toastMsg('error', '请保证指标至少有一个具体条件')
        return
      }
      // 判断维度至少有一个是有条件的
      let analyseDimensionDataCount = 0
      for (let one of this.analyseDimensionData) {
        if (one.dimension.length > 0) {
          analyseDimensionDataCount = analyseDimensionDataCount + 1
        }
      }
      if (analyseDimensionDataCount === 0) {
        _g.toastMsg('error', '请保证维度至少有一个具体条件')
        return
      }
      const analyseDimensionData = this.handleAnalyseDimensionData()
      searchTermsAll.searchDimension = analyseDimensionData
      searchTermsAll.modelId = this.formInline.modelId
      searchTermsAll.searchQuota = this.analyseQuotaData
      // searchTermsAll.searchDimension = this.analyseDimensionData
      // 处理参数
      let data = {}
      data.type = 1
      data.name = this.otherSaveForm.name
      let terms = JSON.stringify(searchTermsAll)
      data.filterJson = terms
      data.modelId = this.formInline.modelId
      data = JSON.stringify(data)
      let idArray = JSON.parse(this.myStorage.getItem('itemFigures'))
      console.log('data', data)
      analyseSaveSingle(data).then((res) => {
        if (res.data.code === '200') {
          this.otherSaveSingleDialog = false
          _g.toastMsg('success', '另存成功')
          // this.analyseQuotaData = searchTermsAll.searchQuota
          // this.allTerms = searchTermsAll.search
          // this.searchPeople = searchTermsAll.searchPeople
          // this.analyseDimensionData = searchTermsAll.searchDimension
          // this.allRelationshipSearch = searchTermsAll.search.allRelationship
          // this.forSonTerms = searchTermsAll.search.termsGroup
          // this.getEdit(searchTermsAll, this.limit, this.page)
        } else {
          _g.toastMsg('error', res.data.des)
        }
      })
    },
    // 更新看板默认显示参数
    saveDashBoardAction (id, itemFigures) {
      let newFiguresArray = []
      for (let it of itemFigures) {
        newFiguresArray.push({
          id: it.id,
          name: it.name,
          position: it.position,
          type: it.type,
          showType: it.showType || '',
        })
      }
      updateDashBoard(id, newFiguresArray).then(res => {
        router.push({ path: '/home/board-list' })
        if (res.data.code === 0) {
          if (type === 1) {
            _g.toastMsg('success', '保存成功')
          }
        } else {
          _g.toastMsg('error', res.data.des)
        }

      })
    },
    addSingleChartAction (singleId, idArray) {
      // this.saveDashBoardAction(res.data.result.id, idArray)
      addSingleChartToDashBoard(this.dashBoardId, singleId).then(res => {
        if (res.data.code === '200' || res.data.code == 0) {
          console.log('添加单图成功')
          this.saveDashBoardAction(singleId, idArray)
        } else {
          _g.TostMsg('error', res.data.message)
          router.push({ path: '/home/board-list' })
        }
      })

    },
    // 暂存单图名字
    saveSingleNameOnly () {
      this.showSingleName = false
      this.editSingleNameShow = this.editSingleName
    },
    // 显示保存名字的input
    openEditName () {
      this.showSingleName = true
      this.editSingleName = this.editSingleNameShow
    },
    // 另存为弹窗
    otherSave () {
      this.otherSaveSingleDialog = true
    },
    // 编辑保存
    editSave () {
      let searchTermsAll = {}
      searchTermsAll.searchPeople = parseInt(this.formInline.analyse_people)
      // 处理高级查询传来的条件
      let termsSend = JSON.parse(JSON.stringify(this.realAllTerms))
      for (let item of termsSend.termsGroup) {
        for (let one of item.terms) {
          let str = ''
          if (one.selectedOptions.length > 0 && one.selectedOptions[0] === 'attr') {
            str = one.selectedOptions[1].split('@')[0]
          }
          if (one.selectedOptions.length > 0 && one.selectedOptions[0] === 'event') {
            str = one.selectedOptions[2]
          }
          if (one.selectedOptions.length > 0 && one.selectedOptions[0] === 'group') {
            str = one.selectedOptions[1].split('@')[0]
          }
          if (one.selectedOptions.length > 0 && one.selectedOptions[0] === 'aud_portary') {
            str = 'tag'
          }
          if (one.selectedOptions.length > 0 && one.selectedOptions[0] === 'wechat_open_id') {
            str = one.selectedOptions[1].split('@')[0]
          }
          if (one.selectedOptions.length > 0 && one.selectedOptions[0] === 'customer_kpi') {
            str = one.selectedOptions[1].split('@')[0]
          }
          // 处理生日为字符串
          if (one.selectedOptions[0] === 'attr' && one.selectedOptions[1].split('@')[1] === 'datePicker') {
            let d = new Date(one.value)
            let month = d.getMonth() + 1 < 10 ? '0' + (d.getMonth() + 1) : d.getMonth() + 1
            let day = d.getDate() < 10 ? '0' + (d.getDate()) : d.getDate()
            one.value = d.getFullYear() + '-' + month + '-' + day
          }
          let firAttr = one.selectedOptions[0]
          one.attr = firAttr
          one.secAttr = str
        }
      }
      searchTermsAll.search = termsSend
      // 判断指标至少有一个是有条件的
      let analyseQuotaCount = 0
      for (let one of this.analyseQuotaData) {
        if (one.analyseQuota.length > 0) {
          analyseQuotaCount = analyseQuotaCount + 1
        }
      }
      if (analyseQuotaCount === 0) {
        _g.toastMsg('error', '请保证指标至少有一个具体条件')
        return
      }
      // 判断维度至少有一个是有条件的
      let analyseDimensionDataCount = 0
      for (let one of this.analyseDimensionData) {
        if (one.dimension.length > 0) {
          analyseDimensionDataCount = analyseDimensionDataCount + 1
        }
      }
      if (analyseDimensionDataCount === 0) {
        _g.toastMsg('error', '请保证维度至少有一个具体条件')
        return
      }
      const analyseDimensionData = this.handleAnalyseDimensionData()
      searchTermsAll.searchDimension = analyseDimensionData
      searchTermsAll.modelId = this.formInline.modelId
      searchTermsAll.searchQuota = this.analyseQuotaData
      // searchTermsAll.searchDimension = this.analyseDimensionData

      customerAnalyseSingleEdit(this.editId, this.editSingleName, JSON.stringify(searchTermsAll), this.formInline.modelId).then((res) => {
        if (res.data.code === '200') {
          _g.toastMsg('success', '保存成功')
        } else {
          _g.toastMsg('error', res.data.des)
        }
      })
    },
    // 打开单图弹窗
    openSave () {
      this.saveSingleDialog = true
    },
    // 保存为单图
    confirmSave () {
      // 处理查询条件
      let searchTermsAll = {}
      searchTermsAll.searchPeople = this.formInline.analyse_people
      // 处理高级查询传来的条件
      let termsSend = JSON.parse(JSON.stringify(this.realAllTerms))
      for (let item of termsSend.termsGroup) {
        for (let one of item.terms) {
          let str = ''
          if (one.selectedOptions.length > 0 && one.selectedOptions[0] === 'attr') {
            str = one.selectedOptions[1].split('@')[0]
          }
          if (one.selectedOptions.length > 0 && one.selectedOptions[0] === 'event') {
            str = one.selectedOptions[2]
          }
          if (one.selectedOptions.length > 0 && one.selectedOptions[0] === 'group') {
            str = one.selectedOptions[1].split('@')[0]
          }
          if (one.selectedOptions.length > 0 && one.selectedOptions[0] === 'wechat_open_id') {
            str = one.selectedOptions[1].split('@')[0]
          }
          if (one.selectedOptions.length > 0 && one.selectedOptions[0] === 'aud_portary') {
            str = 'tag'
          }
          if (one.selectedOptions.length > 0 && one.selectedOptions[0] === 'customer_kpi') {
            str = one.selectedOptions[1].split('@')[0]
          }
          // 处理生日为字符串
          if (one.selectedOptions[0] === 'attr' && one.selectedOptions[1].split('@')[1] === 'datePicker') {
            let d = new Date(one.value)
            let month = d.getMonth() + 1 < 10 ? '0' + (d.getMonth() + 1) : d.getMonth() + 1
            let day = d.getDate() < 10 ? '0' + (d.getDate()) : d.getDate()
            one.value = d.getFullYear() + '-' + month + '-' + day
          }
          let firAttr = one.selectedOptions[0]
          one.attr = firAttr
          one.secAttr = str
        }
      }
      searchTermsAll.search = termsSend
      // 判断指标至少有一个是有条件的
      let analyseQuotaCount = 0
      for (let one of this.analyseQuotaData) {
        if (one.analyseQuota.length > 0) {
          analyseQuotaCount = analyseQuotaCount + 1
        }
      }
      if (analyseQuotaCount === 0) {
        _g.toastMsg('error', '请保证指标至少有一个具体条件')
        return
      }
      // 判断维度至少有一个是有条件的
      let analyseDimensionDataCount = 0
      for (let one of this.analyseDimensionData) {
        if (one.dimension.length > 0) {
          analyseDimensionDataCount = analyseDimensionDataCount + 1
        }
      }
      if (analyseDimensionDataCount === 0) {
        _g.toastMsg('error', '请保证维度至少有一个具体条件')
        return
      }
      const analyseDimensionData = this.handleAnalyseDimensionData()
      searchTermsAll.searchDimension = analyseDimensionData
      searchTermsAll.modelId = this.formInline.modelId
      // searchTermsAll.searchDimension = this.analyseDimensionData
      searchTermsAll.searchQuota = this.analyseQuotaData
      // 处理参数
      let data = {}
      data.type = 1
      data.modelId = this.formInline.modelId
      data.name = this.saveForm.name
      let terms = JSON.stringify(searchTermsAll)
      data.filterJson = terms
      data = JSON.stringify(data)
      let layoutArr = JSON.parse(this.myStorage.getItem('itemLayout'))
      let idArray = JSON.parse(this.myStorage.getItem('itemFigures'))
      let maxY = 0
      if (layoutArr && layoutArr.length >= 2) {
        for (let x = 0; x < layoutArr.length - 1; x++) {
          if (layoutArr[x].y !== null) {
            maxY = maxY < layoutArr[x + 1].y ? layoutArr[x + 1].y : maxY
          }
        }
      }
      console.log(idArray, '在tianjia1zhiqian1')
      analyseSaveSingle(data).then((res) => {
        if (res.data.code === '200') {
          this.saveSingleDialog = false
          idArray.push({
            id: res.data.result.id,
            name: res.data.result.name,
            position: JSON.stringify([0, maxY + 9, 9, 6]),
            type: '',
            showType: this.showTypeCont
          })
          if (this.isAdd === 'true') {
            layoutArr.push({
              'x': 0,
              'y': maxY + 9,
              'w': 9,
              'h': 6,
              'i': res.data.result.id,
              'showType': this.showTypeCont,
              'type': res.data.result.type,
              'name': res.data.result.name
            })
            this.myStorage.setItem('itemLayout', JSON.stringify(layoutArr))
            this.myStorage.setItem('itemFigures', JSON.stringify(idArray))
            this.addSingleChartAction(res.data.result.id, idArray)
            this.myStorage.setItem('borderDetailsIsAdd', 'false')
          }

          _g.toastMsg('success', res.data.message)
        } else {
          _g.toastMsg('error', res.data.message)
        }
      })
    },
    // ant-table的条数
    totals (total, range) {
      total = this.totalCount
      return '共 ' + total + ' 条'
    },
    // 新版分页
    onChange (pageNumber) {
    },
    // 饼图
    chartPieOne () {
      this.myChartPie = this.$echarts.init(document.getElementById('chartPie'))
      this.myChartPie.setOption({
        tooltip: {
          trigger: 'item',
          formatter: '{a} <br/>{b}: {c} ({d}%)'
        },
        legend: {
          type: 'scroll',
          orient: 'vertical',
          left: 20,
          top: 20,
          bottom: 20,
          data: this.chartDataX
        },
        series: [
          {
            name: this.xNamePie,
            type: 'pie',
            radius: ['50%', '70%'],
            avoidLabelOverlap: false,
            label: {
              normal: {
                show: false,
                position: 'outside'
              },
              emphasis: {
                show: false,
                textStyle: {
                  fontSize: '20',
                  fontWeight: 'bold'
                }
              }
            },
            labelLine: {
              normal: {
                show: false
              }
            },
            itemStyle: {
              color: function (params) {
                var colorList = ['#f5be00', '#00ffb4', '#ff2797', '#9f45fb', '#00f5f2', '#ff4949', '#2cff27', '#fd932b', '#ff5fdf', '#4c61fe', '#ed661c', '#45b0fb', '#3400f5', '#ff8c8c', '#ff2797', '＃acbf5d', '#62bba1', '#80ba4d', '#254fa3', '#fbda78', '#3e9389', '#843583', '#64daff', '#9bc1de', '#7b9df9', '#9ab899', '#fcceac', '#e94b63', '#f073ab', '#6d8345', '#9c95c9', '#cd9a5b', '#decc00', '#d4c59e', '#7d5786', '#95d6da', '#018792', '#b44333', '#d68989', '#fece7a']
                return colorList[params.dataIndex]
              }
            },
            data: this.chartDataYPie
          }
        ]
      })
      this.myChartPie.resize()
    },
    // 折线图
    chartLineOne () {
      this.myChartLine = this.$echarts.init(document.getElementById('chartLine'))
      this.myChartLine.setOption({
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          }
        },
        grid: {
          left: '10%',
          right: '10%',
          bottom: '10%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          data: this.chartDataX,
          name: this.xNames
        },
        yAxis: {
          type: 'value',
          name: this.yNames
        },
        series: [{
          data: this.chartDataY,
          type: 'line',
          lineStyle: {
            color: '#1980FF'
          },
          areaStyle: {
            normal: {
              color: '#1980FF'
            },
            color: '#CCE3FF'
          },
          itemStyle: {
            normal: {
              color: '#1980FF'
            }
          }
        }]
      })
      this.myChartLine.resize()
    },
    // 柱状图
    chartZhuOne () {
      if (this.chartDataX.length <= 10) {
        this.barWidth = '56px'
      }
      if (this.chartDataX.length > 10) {
        this.barWidth = '24px'
      }
      this.myChartZhu = this.$echarts.init(document.getElementById('chartZhu'))
      this.myChartZhu.setOption({
        color: ['#1980FF'],
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          }
        },
        grid: {
          left: '10%',
          right: '10%',
          bottom: '10%',
          containLabel: true
        },
        xAxis: [
          {
            type: 'category',
            boundaryGap: true,
            data: this.chartDataX,
            axisTick: {
              alignWithLabel: true
            },
            name: this.xNames
          }
        ],
        yAxis: [
          {
            type: 'value',
            name: this.yNames
          }
        ],
        series: [
          {
            name: this.yNames,
            type: 'bar',
            barWidth: this.barWidth,
            data: this.chartDataY
          }
        ]
      })
      this.myChartZhu.resize()
    },
    // 选择表格查询结果
    chooseTable () {
      this.showTypeCont = 'table'
      this.showType.table.choosed = true
      this.showType.pie.choosed = false
      this.showType.line.choosed = false
      this.showType.zhu.choosed = false
      this.showType.num.choosed = false
    },
    // 选择柱状查询结果
    chooseZhu () {
      this.showTypeCont = 'barGraph'
      this.showType.table.choosed = false
      this.showType.pie.choosed = false
      this.showType.line.choosed = false
      this.showType.zhu.choosed = true
      this.showType.num.choosed = false
      let myChart = document.getElementById('chartZhu')
      myChart.style.width = '100%'
      setTimeout(() => {
        this.chartZhuOne()
      }, 30)
    },
    // 选择线查询结果
    chooseLine () {
      this.showTypeCont = 'lineChart'
      this.showType.table.choosed = false
      this.showType.pie.choosed = false
      this.showType.line.choosed = true
      this.showType.zhu.choosed = false
      this.showType.num.choosed = false
      let myChart = document.getElementById('chartLine')
      myChart.style.width = '100%'
      setTimeout(() => {
        this.chartLineOne()
      }, 30)
    },
    // 选择饼查询结果
    choosePie () {
      this.showTypeCont = 'pieChart'
      this.showType.table.choosed = false
      this.showType.pie.choosed = true
      this.showType.line.choosed = false
      this.showType.zhu.choosed = false
      this.showType.num.choosed = false
      let myChart = document.getElementById('chartPie')
      myChart.style.width = '100%'
      setTimeout(() => {
        this.chartPieOne()
      }, 30)
    },
    // 选择数字查询结果
    chooseNum () {
      this.showTypeCont = 'singleMetric'
      this.showType.table.choosed = false
      this.showType.pie.choosed = false
      this.showType.line.choosed = false
      this.showType.zhu.choosed = false
      this.showType.num.choosed = true
    },
    // 开始查询
    startSearch () {

      this.showType.table.is_have = false
      this.showType.zhu.is_have = false
      this.showType.line.is_have = false
      this.showType.pie.is_have = false
      this.showType.num.is_have = false
      let searchTermsAll = {}
      searchTermsAll.searchPeople = this.formInline.analyse_people
      // 处理高级查询传来的条件
      let termsSend = JSON.parse(JSON.stringify(this.realAllTerms))
      for (let item of termsSend.termsGroup) {
        for (let one of item.terms) {
          let str = ''

          if (one.selectedOptions.length > 0 && one.selectedOptions[0] === 'attr') {
            str = one.selectedOptions[1].split('@')[0]
          }
          if (one.selectedOptions.length > 0 && one.selectedOptions[0] === 'wechat_open_id') {
            str = one.selectedOptions[1].split('@')[0]
          }
          if (one.selectedOptions.length > 0 && one.selectedOptions[0] === 'event') {
            str = one.selectedOptions[2]
          }
          if (one.selectedOptions.length > 0 && one.selectedOptions[0] === 'group') {
            str = one.selectedOptions[1].split('@')[0]
          }
          if (one.selectedOptions.length > 0 && one.selectedOptions[0] === 'aud_portary') {
            str = 'tag'
          }
          if (one.selectedOptions.length > 0 && one.selectedOptions[0] === 'customer_kpi') {
            str = one.selectedOptions[1].split('@')[0]
          }
          if (one.selectedOptions.length > 0 && one.selectedOptions[0] === 'follow_public') {
            str = one.selectedOptions[1].split('@')[0]
          }
          // 判断是否群组group/标签aud_portary
          if (one.selectedOptions[0] === 'group' || one.selectedOptions[0] === 'aud_portary') {
            delete one.eventAttrOptions
            delete one.eventDateEnd
            delete one.eventDateStart
            delete one.relationOptions
            delete one.option
          }
          // 处理生日为字符串
          if (one.selectedOptions[0] === 'attr' && one.selectedOptions[1].split('@')[1] === 'datePicker') {
            let d = new Date(one.value)
            let month = d.getMonth() + 1 < 10 ? '0' + (d.getMonth() + 1) : d.getMonth() + 1
            let day = d.getDate() < 10 ? '0' + (d.getDate()) : d.getDate()
            one.value = d.getFullYear() + '-' + month + '-' + day
          }
          let firAttr = one.selectedOptions[0] === 'wechat_open_id' ? 'attr' : one.selectedOptions[0]

          one.attr = firAttr
          one.secAttr = str
          delete one.option
          delete one.relationOptions
          // 判断是否事件
          if (one.selectedOptions[0] === 'event') {
            delete one.relationOptions
            delete one.option
            delete one.eventAttributeList
          }
          delete one.selectedOptions
        }
      }
      searchTermsAll.search = termsSend
      // 判断指标至少有一个是有条件的
      let analyseQuotaCount = 0
      for (let one of this.analyseQuotaData) {
        if (one.analyseQuota.length > 0) {
          analyseQuotaCount = analyseQuotaCount + 1
        }
      }

      if (analyseQuotaCount === 0) {
        _g.toastMsg('error', '请保证指标至少有一个具体条件')
        return
      }
      // 判断维度至少有一个是有条件的
      let analyseDimensionDataCount = 0
      for (let one of this.analyseDimensionData) {
        if (one.dimension.length > 0) {
          analyseDimensionDataCount = analyseDimensionDataCount + 1
        }
      }
      if (analyseDimensionDataCount === 0) {
        _g.toastMsg('error', '请保证维度至少有一个具体条件')
        return
      }
      // 处理维度要传给后端的入参形式
      const analyseDimensionData = this.handleAnalyseDimensionData()

      searchTermsAll.modelId = this.formInline.modelId
      searchTermsAll.searchQuota = this.analyseQuotaData
      // searchTermsAll.searchDimension = this.analyseDimensionData
      searchTermsAll.searchDimension = analyseDimensionData
      this.searchTermsAllLocal = searchTermsAll
      customerAnalyseSearch(JSON.stringify(searchTermsAll), this.limit, this.page).then((res) => {
        if (res.data.code === '200') {
          this.showResult = true
          this.showType.table.choosed = true
          this.showType.zhu.choosed = true
          this.showType.line.choosed = true
          this.showType.pie.choosed = true
          this.showType.num.choosed = true
          this.$nextTick(() => {
            // 判断默认选中
            if (res.data.result.defaultShow === 'table') {
              this.showType.table.choosed = true
              this.showType.zhu.choosed = false
              this.showType.line.choosed = false
              this.showType.pie.choosed = false
              this.showType.num.choosed = false
            }
            if (res.data.result.defaultShow === 'barGraph') {
              this.showType.table.choosed = false
              this.showType.zhu.choosed = true
              this.showType.line.choosed = false
              this.showType.pie.choosed = false
              this.showType.num.choosed = false
            }
            if (res.data.result.defaultShow === 'lineChart') {
              this.showType.table.choosed = false
              this.showType.zhu.choosed = false
              this.showType.line.choosed = true
              this.showType.pie.choosed = false
              this.showType.num.choosed = false
            }
            if (res.data.result.defaultShow === 'pieChart') {
              this.showType.table.choosed = false
              this.showType.zhu.choosed = false
              this.showType.line.choosed = false
              this.showType.pie.choosed = true
              this.showType.num.choosed = false
            }
            if (res.data.result.defaultShow === 'singleMetric') {
              this.showType.table.choosed = false
              this.showType.zhu.choosed = false
              this.showType.line.choosed = false
              this.showType.pie.choosed = false
              this.showType.num.choosed = true
            }
          })
          // 如果只有单值
          if (res.data.result.hasSingleMetric === 1) {
            this.resultNum = res.data.result.singleMetric
            this.showType.num.is_have = true
          }
          // 如果只有表格
          if (res.data.result.hasTable === 1) {
            this.columns = res.data.result.tableData.columns
            this.tableData = res.data.result.tableData.tableData
            this.excelData = res.data.result.tableData.exportData
            this.totalCount = res.data.result.tableData.total
            this.showType.table.is_have = true
          }
          // 如果只有柱状图
          if (res.data.result.hasBarGraph === 1) {
            let xData = []
            let yData = []
            for (let item of res.data.result.barLinePieData.valueList) {
              xData.push(item.x)
              yData.push(item.y)
            }
            this.chartDataX = xData
            this.chartDataYBar = yData
            this.showType.zhu.is_have = true
            this.xNames = res.data.result.barLinePieData.xName
            this.yNames = res.data.result.barLinePieData.yName
            let myChart = document.getElementById('chartZhu')
            myChart.style.width = '100%'
            setTimeout(() => {
              this.chartZhuOne()
            }, 30)
          }
          // 如果只有饼状图
          if (res.data.result.hasPieChart === 1) {
            let xData = []
            let yData = []
            for (let item of res.data.result.barLinePieData.valueList) {
              xData.push(item.x)
              yData.push({
                value: item.y,
                name: item.x
              })
            }
            this.chartDataX = xData
            this.chartDataYPie = yData
            this.xNamePie = res.data.result.barLinePieData.xName
            this.showType.pie.is_have = true
            let myChart = document.getElementById('chartPie')
            myChart.style.width = '100%'
            setTimeout(() => {
              this.chartPieOne()
            }, 30)
          }
          // 如果只有折线图
          if (res.data.result.hasLineChart === 1) {
            let xData = []
            let yData = []
            for (let item of res.data.result.barLinePieData.valueList) {
              xData.push(item.x)
              yData.push(item.y)
            }
            this.chartDataX = xData
            this.chartDataY = yData
            this.showType.line.is_have = true
            this.xNames = res.data.result.barLinePieData.xName
            this.yNames = res.data.result.barLinePieData.yName
            let myChart = document.getElementById('chartLine')
            myChart.style.width = '100%'
            setTimeout(() => {
              this.chartLineOne()
            }, 30)
          }
        } else { }
      })
    },
    // 处理维度入参
    handleAnalyseDimensionData () {
      const analyseDimensionData = this.analyseDimensionData.map(item => {
        let interval = []
        if (item.sectionFormLine) {
          interval = item.sectionFormLine.sectionList.map(ele => {
            if (ele.maxValue === '+∞' || ele.maxValue === '') {
              ele.maxValue = INFINITY
            }
            return {
              o: ele.index,
              n: ele.name,
              s: ele.minValue === '-∞' ? NEGATIVE_INFINITY : ele.minValue,
              e: ele.maxValue
            }
          })
        }
        // interval这个值要不要传给后端取决于 页面中展示还是不展示设置的图标
        if (item.showSetValue) {
          return {
            dimension: item.dimension,
            interval
          }
        } else {
          return {
            dimension: item.dimension
          }
        }

      })
      return analyseDimensionData
    },
    // 添加维度
    addAnalyseDimension () {
      this.analyseDimensionData.push({
        dimension: [],
        sectionFormLine: {
          sectionList: [{
            minValue: '-∞',
            maxValue: '',
            name: '',
            disabled: false, // 控制是否展示删除按钮
            showSymbol: true, // 控制是否展示+∞
            index: 0
          }],
        },
        showSetValue: false,
        showSetValueDialog: false
      })
    },
    // 删除维度
    removeDimensionItem (two, j) {
      if (this.analyseDimensionData.length === 1) {
        return
      }
      this.analyseDimensionData.splice(j, 1)
      for (let one of this.analyseDimensionOptions) {
        if (one.children) {
          for (let item of one.children) {
            if (two.dimension[1] === item.value) {
              item.disabled = false
            }
          }
        } else {
          if (one.value === two.dimension[0]) {
            one.disabled = false
          }
        }
      }
    },
    // 切换维度
    changeDimension (val, index) {
      this.$nextTick(() => {
        // 通过判断控制设置图标是否展示
        if (val[0] === 'key_indicators' || ATTR_LIST.includes(val[1])) {
          this.$set(this.analyseDimensionData[index], 'showSetValue', true)
        } else {
          this.$set(this.analyseDimensionData[index], 'showSetValue', false)
        }
        // 切换时，重置设置区间弹窗数据
        this.analyseDimensionData[index].sectionFormLine.sectionList = SECTION_LIST_INIT
      })
      for (let one of this.analyseDimensionOptions) {
        if (one.children) {
          for (let item of one.children) {
            item.disabled = false
            for (let k of this.analyseDimensionData) {
              if (item.value === k.dimension[1]) {
                item.disabled = true
              }
            }
          }
        } else {
          one.disabled = false
          for (let k of this.analyseDimensionData) {
            if (one.value === k.dimension[0]) {
              one.disabled = true
            }
          }
        }
      }
    },
    // 删除指标
    removeQuotaItem (o, i) {
      if (this.analyseQuotaData.length === 1) {
        return
      }
      this.analyseQuotaData.splice(i, 1)
      for (let one of this.analyseQuotaOptions) {
        for (let item of one.children) {
          for (let k of item.children) {
            if (k.value === o.analyseQuota[2] && item.value === o.analyseQuota[1]) {
              k.disabled = false
            }
          }
        }
      }
    },
    // 添加指标
    addAnalyseQuota () {
      this.analyseQuotaData.push({
        analyseQuota: []
      })
    },
    // 切换指标
    changeQuota () {
      for (let one of this.analyseQuotaOptions) {
        for (let item of one.children) {
          for (let k of item.children) {
            k.disabled = false
            for (let h of this.analyseQuotaData) {
              if (k.value === h.analyseQuota[2] && item.value === h.analyseQuota[1]) {
                k.disabled = true
              }
            }
          }
        }
      }
    },
    // 获取子组件的查询条件
    getAllTerms (value) {
      this.allTerms = value
    },
    exporeAction () {
      let str = ''
      for (let item of this.columns) {
        str = str + item.title + ','
      }
      str = str.substring(0, str.lastIndexOf(','))
      str = str + '\n'
      // 增加\t为了不让表格显示科学计数法或者其他格式
      for (let excelItem of this.excelData) {
        let tmpArray = []
        for (let key in excelItem) {
          let tmp = excelItem[key] + ''
          tmp = tmp.replace(/,/g, '')
          tmpArray.push(tmp)
        }
        str += tmpArray.join(',') + '\n'
      }
      // encodeURIComponent解决中文乱码
      let uri = 'data:text/csv;charset=utf-8,\ufeff' + encodeURIComponent(str)
      // 通过创建a标签实现
      let link = document.createElement('a')
      link.href = uri
      // 对下载的文件命名
      link.download = '数据表.csv'
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    },
    download (data) {
      if (!data) {
        return
      }
      var now = new Date()
      var year = now.getFullYear()
      var month = (now.getMonth() + 1 < 10 ? '0' + (now.getMonth() + 1) : (now.getMonth()) + 1)
      var date = now.getDate()
      var hour = now.getHours()
      var minute = now.getMinutes()
      var second = now.getSeconds()
      let time = ''
      time = year + '' + month + '' + date + '' + hour + '' + minute + '' + second
      var blob = new Blob([data.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8' }) // application/vnd.openxmlformats-officedocument.spreadsheetml.sheet这里表示xlsx类型
      var downloadElement = document.createElement('a')
      var href = window.URL.createObjectURL(blob) // 创建下载的链接
      downloadElement.href = href
      downloadElement.download = time + '.xlsx' // 下载后文件名
      document.body.appendChild(downloadElement)
      downloadElement.click() // 点击下载
      document.body.removeChild(downloadElement) // 下载完成移除元素
      window.URL.revokeObjectURL(href) // 释放掉blob对象
    },
    // 加载
    load () {
      this.loading = true
      // 获取群组列表
      let getGroup = getAudGroupGroupList(this.formInline.modelId, '')
      // 获取属性列表
      // let getAttr = getCusAttrList(this.formInline.modelId)
      // 获取事件列表
      let loadEvent = getCusEventList(1, 0, '')
      // 获取公众号列表
      let loadWechatPublicList = getWechatPublicListForNode(1, '')
      // 获取微页面列表
      let loadWepageList = getWePagesListForNode(1, '')
      // 获取短信列表
      let loadSmsList = getMessageListForNode(1, '')
      // 获取大转盘列表
      let loadBigWheelList = getBigWheelList()
      // 请求客户等级
      let loadStage = getCusStageList(this.formInline.modelId)
      // 请求客户来源
      let loadSource = getSourceData()
      // 发送promiss请求并处理
      Promise.all([getGroup, loadWechatPublicList, loadWepageList, loadSmsList, loadBigWheelList, loadEvent, loadStage, loadSource]).then(res => {
        // 处理群组
        if (res[0].data.code === '200') {
          // 处理之后给翻译用
          for (let i of res[0].data.result) {
            this.groupShow[i.id] = i.name
          }
          this.groupShow[0] = '全部'
          // 处理给分析人群
          res[0].data.result.unshift({
            id: '',
            name: '全部'
          })
        }
        // 处理公众号列表
        if (res[1].data.code === 0) {
          for (let item of res[1].data.data.list) {
            item.label = item.nick_name
            item.value = item.id
          }
          this.wechatPublic = res[1].data.data.list
          for (let item of res[1].data.data.list) {
            this.wechatUse[item.id] = item.nick_name
          }
        }
        // 处理受众事件
        if (res[5].data.code === '200') {
          // 拼接处理获得的事件列表到本地数据
          let data = res[5].data.result.list
          for (let i of data) {
            this.events[i.identity] = i.name
          }
          // 处理回显
          let queryJsons = sessionStorage.getItem('queryJson')
          if (this.editId !== undefined && queryJsons !== undefined) {
            this.filterName = '修改人群筛选条件'
            this.queryJson = JSON.parse(queryJsons)
            this.formInline.modelId = this.queryJson.modelId
            for (let one of this.analyseQuotaOptions) {
              for (let item of one.children) {
                for (let k of item.children) {
                  k.disabled = false
                  for (let h of this.queryJson.searchQuota) {
                    if (k.value === h.analyseQuota[2] && item.value === h.analyseQuota[1]) {
                      k.disabled = true
                    }
                  }
                }
              }
            }
            this.analyseQuotaData = this.queryJson.searchQuota
            // 处理筛选条件
            for (let one of this.queryJson.search.termsGroup) {
              for (let item of one.terms) {
                if (
                  (item.selectedOptions[0] === 'attr' &&
                    item.selectedOptions[1].split('@')[1] === 'dateTimePicker') ||
                  (item.selectedOptions[0] === 'attr' &&
                    item.selectedOptions[1].split('@')[1] === 'datePicker')) {
                  item.relationOptions = [
                    {
                      value: 'equal',
                      label: '等于'
                    },
                    {
                      value: 'not_equal',
                      label: '不等于'
                    },
                    {
                      value: 'lt',
                      label: '早于'
                    },
                    {
                      value: 'gt',
                      label: '晚于'
                    },
                    {
                      value: 'gtele',
                      label: '区间'
                    }
                  ]
                }
                if (
                  item.selectedOptions[1].split('@')[1] === 'input') {
                  item.relationOptions = [
                    {
                      value: 'equal',
                      label: '等于'
                    }, {
                      value: 'not_equal',
                      label: '不等于'
                    }, {
                      value: 'contain',
                      label: '包含'
                    }, {
                      value: 'not_contain',
                      label: '不包含'
                    }, {
                      value: 'empty',
                      label: '为空'
                    },
                    {
                      value: 'not_empty',
                      label: '不为空'
                    }
                  ]
                }
                if (
                  item.selectedOptions[1].split('@')[1] === 'select') {
                  item.relationOptions = [
                    {
                      value: 'equal',
                      label: '等于'
                    }, {
                      value: 'not_equal',
                      label: '不等于'
                    }, {
                      value: 'empty',
                      label: '为空'
                    },
                    {
                      value: 'not_empty',
                      label: '不为空'
                    }
                  ]
                }
                if (
                  item.selectedOptions[1].split('@')[1] === 'dict') {
                  item.relationOptions = [
                    {
                      value: 'equal',
                      label: '等于'
                    }, {
                      value: 'not_equal',
                      label: '不等于'
                    }, {
                      value: 'empty',
                      label: '为空'
                    },
                    {
                      value: 'not_empty',
                      label: '不为空'
                    }
                  ]
                }
                if (item.selectedOptions[1].split('@')[1] === 'addressPicker') {
                  item.relationOptions = [
                    {
                      value: 'equal',
                      label: '等于'
                    }, {
                      value: 'not_equal',
                      label: '不等于'
                    }, {
                      value: 'empty',
                      label: '为空'
                    },
                    {
                      value: 'not_empty',
                      label: '不为空'
                    }
                  ]
                }
                if (item.selectedOptions[1].split('@')[1] === 'multipleSelect') {
                  item.relationOptions = [
                    {
                      value: 'contain',
                      label: '包含'
                    }, {
                      value: 'not_contain',
                      label: '不包含'
                    }, {
                      value: 'empty',
                      label: '为空'
                    },
                    {
                      value: 'not_empty',
                      label: '不为空'
                    }
                  ]
                }
                if (item.selectedOptions[1].split('@')[1] === 'number') {
                  item.relationOptions = [
                    {
                      value: 'equal',
                      label: '等于'
                    }, {
                      value: 'not_equal',
                      label: '不等于'
                    }, {
                      value: 'gt',
                      label: '大于'
                    }, {
                      value: 'lt',
                      label: '小于'
                    }, {
                      value: 'gtele',
                      label: '区间'
                    }
                  ]
                }
                if (item.selectedOptions[1].split('@')[1] === 'model') {
                  item.relationOptions = [
                    {
                      value: 'contain',
                      label: '包含'
                    }, {
                      value: 'not_contain',
                      label: '不包含'
                    }, {
                      value: 'empty',
                      label: '为空'
                    },
                    {
                      value: 'not_empty',
                      label: '不为空'
                    }
                  ]
                }
                if (item.selectedOptions[0] === 'aud_portary') {
                  /* -------------自定义属性的相对关系------------ */
                  // 文本
                  if (item.selectedOptions[1].split('@')[0] === 'tag') {
                    item.relationOptions = [
                      {
                        value: 'contain',
                        label: '包含'
                      }, {
                        value: 'not_contain',
                        label: '不包含'
                      }, {
                        value: 'empty',
                        label: '为空'
                      },
                      {
                        value: 'not_empty',
                        label: '不为空'
                      }
                    ]
                  }
                }
                //  受众身份
                if (item.selectedOptions[0] === 'wechat_open_id') {
                  /* -------------自定义属性的相对关系------------ */
                  // 文本
                  if (item.selectedOptions[1].split('@')[0] === 'input') {
                    item.relationOptions = [
                      {
                        value: 'equal',
                        label: '等于'
                      }, {
                        value: 'not_equal',
                        label: '不等于'
                      }, {
                        value: 'empty',
                        label: '为空'
                      },
                      {
                        value: 'not_empty',
                        label: '不为空'
                      }
                    ]
                  }
                }
                // 来源
                if (item.selectedOptions[1].split('@')[0] === 'source_id') {
                  getCustomerSources(1, 10000, '').then((resb) => {
                    item.option = []
                    for (let b of resb.data.result.list) {
                      item.option.push({
                        name: b.name,
                        id: b.id
                      })
                    }
                  })
                }

                // 来源
                if (item.selectedOptions[1].split('@')[0] === 'stage_id') {
                  getCusStageList(this.formInline.modelId).then((res) => {
                    item.option = [
                      {
                        name: '未知等级',
                        id: 0
                      }
                    ]
                    for (let a of res.data.result) {
                      item.option.push({
                        name: a.name,
                        id: a.id
                      })
                    }
                  })
                }
                // 处理群组回显
                if (item.selectedOptions[0] === 'group') {
                  getAudGroupList(this.formInline.modelId, 1, 1000, '', '').then((res) => {
                    for (let j of res.data.result.list) {
                      j.label = j.name
                      j.value = j.id
                    }
                    item.option = res.data.result.list
                  })
                }
              }
            }
            this.allTerms = this.queryJson.search
            sessionStorage.setItem(this.formInline.modelId, JSON.stringify(this.allTerms))

            if (this.queryJson.search.termsGroup[0].terms[0].secAttr === '') {
              this.is_show_analyse_show = false
            }
            if (this.queryJson.search.termsGroup[0].terms[0].secAttr !== '') {
              this.is_show_analyse_show = true
            }
            this.realAllTerms = this.queryJson.search
            this.formInline.analyse_people = this.queryJson.searchPeople
            // for (let one of this.analyseDimensionOptions) {
            //   if (one.children) {
            //     for (let item of one.children) {
            //       item.disabled = false
            //       for (let k of this.queryJson.searchDimension) {
            //         if (item.value === k.dimension[1]) {
            //           item.disabled = true
            //         }
            //       }
            //     }
            //   } else {
            //     one.disabled = false
            //     for (let k of this.queryJson.searchDimension) {
            //       if (one.value === k.dimension[0]) {
            //         one.disabled = true
            //       }
            //     }
            //   }
            // }
            // this.analyseDimensionData = this.queryJson.searchDimension

            // 回显分析维度设置数值区间
            this.handleSearchDimension()
            this.allRelationshipSearch = this.queryJson.search.allRelationship
            this.allRelationship = this.queryJson.search.allRelationship
            this.analysePeopleListOne = JSON.parse(JSON.stringify(this.analysePeopleList))
            for (let i of this.analysePeopleListOne) {
              i.label = i.name
              i.value = i.id
            }
            this.forSonTerms = this.queryJson.search.termsGroup
            this.loadAudGroupAndDimension()
            getAudGroupList(this.formInline.modelId, 1, 1000, '', '').then(res => {
              this.analysePeopleList = []
              if (res.data.code === '200') {
                // 分析人群
                this.analysePeopleList.push({
                  id: 0,
                  name: '全部'
                })
                for (let f of res.data.result.list) {
                  this.divideGroupShow[f.id] = f.name
                  this.analysePeopleList.push(f)
                }
                this.formInline.analyse_people = this.queryJson.searchPeople
              }
            })

            this.getEdit(this.queryJson, this.limit, this.page)
          }
        }
        // 处理客户等级
        if (res[6].data.code === '200') {
          for (let item of res[6].data.result) {
            this.stageUse[item.id] = item.name
          }
        }
        // 处理客户来源
        if (res[7].data.code === 0) {
          for (let item of res[7].data.data.list) {
            this.sourceUse[item.id] = item.name
          }
        }
      })
      if (this.allRelationship) {
        this.outOperator = this.allRelationship
      } else if (this.allRelationshipSearch) {
        this.outOperator = this.allRelationshipSearch
      }
      this.openLoading()
    },
    // 回显分析维度设置数值区间
    handleSearchDimension () {
      const searchDimension = JSON.parse(JSON.stringify(this.queryJson.searchDimension))
      // 分析维度下拉框回显 (这个不是我写的，前人写的)
      for (let one of this.analyseDimensionOptions) {
        if (one.children) {
          for (let item of one.children) {
            item.disabled = false
            for (let k of searchDimension) {
              if (item.value === k.dimension[1]) {
                item.disabled = true
              }
            }
          }
        } else {
          one.disabled = false
          for (let k of searchDimension) {
            if (one.value === k.dimension[0]) {
              one.disabled = true
            }
          }
        }
      }
      // 分析维度设置区间数值回显  这才是我写的
      searchDimension.forEach(item => {
        item.showSetValueDialog = false // 设置数值区间弹窗
        item.showSetValue = !!item.interval  // 无interval不展示设置图标
        if (!item.interval) return
        const sectionList = item.interval.map(ele => {
          return {
            minValue: ele.s === NEGATIVE_INFINITY ? '-∞' : ele.s,
            maxValue: ele.e === INFINITY ? '+∞' : ele.e,
            name: ele.n,
            disabled: ele.e === INFINITY, // 控制是否展示删除按钮
            showSymbol: ele.e === INFINITY, // 控制是否展示+∞
            index: ele.o
          }
        })
        item.sectionFormLine = {
          sectionList
        }
      })

      this.analyseDimensionData = searchDimension
    },
    // 数据加载时的动画
    openLoading () {
      setTimeout(() => {
        this.loading = false
      }, 500)
    },
    // 获取编辑回显
    getEdit (queryJSON, limit, page) {
      let query = JSON.parse(JSON.stringify(queryJSON))

      for (let item of query.search.termsGroup) {
        for (let one of item.terms) {
          // one.relationOptions = []
          if (one.selectedOptions.length > 0 && one.selectedOptions[0] === 'follow_public') {
            one.secAttr = one.selectedOptions[1].split('@')[0]
          }
          delete one.relationOptions
          delete one.option
        }
      }
      customerAnalyseSearch(query, limit, page).then((res) => {
        if (res.data.code === '200') {
          this.showResult = true
          this.showType.table.choosed = true
          this.showType.zhu.choosed = true
          this.showType.line.choosed = true
          this.showType.pie.choosed = true
          this.showType.num.choosed = true
          this.$nextTick(() => {
            // 判断默认选中
            if (res.data.result.defaultShow === 'table') {
              this.showType.table.choosed = true
              this.showType.zhu.choosed = false
              this.showType.line.choosed = false
              this.showType.pie.choosed = false
              this.showType.num.choosed = false
            }
            if (res.data.result.defaultShow === 'barGraph') {
              this.showType.table.choosed = false
              this.showType.zhu.choosed = true
              this.showType.line.choosed = false
              this.showType.pie.choosed = false
              this.showType.num.choosed = false
            }
            if (res.data.result.defaultShow === 'lineChart') {
              this.showType.table.choosed = false
              this.showType.zhu.choosed = false
              this.showType.line.choosed = true
              this.showType.pie.choosed = false
              this.showType.num.choosed = false
            }
            if (res.data.result.defaultShow === 'pieChart') {
              this.showType.table.choosed = false
              this.showType.zhu.choosed = false
              this.showType.line.choosed = false
              this.showType.pie.choosed = true
              this.showType.num.choosed = false
            }
            if (res.data.result.defaultShow === 'singleMetric') {
              this.showType.table.choosed = false
              this.showType.zhu.choosed = false
              this.showType.line.choosed = false
              this.showType.pie.choosed = false
              this.showType.num.choosed = true
            }
          })
          // 如果只有单值
          if (res.data.result.hasSingleMetric === 1) {
            this.resultNum = res.data.result.singleMetric
            this.showType.num.is_have = true
          }
          // 如果只有表格
          if (res.data.result.hasTable === 1) {
            this.columns = res.data.result.tableData.columns
            this.tableData = res.data.result.tableData.tableData
            this.totalCount = res.data.result.tableData.total
            this.excelData = res.data.result.tableData.exportData
            this.showType.table.is_have = true
          }
          // 如果只有柱状图
          if (res.data.result.hasBarGraph === 1) {
            let xData = []
            let yData = []
            for (let item of res.data.result.barLinePieData.valueList) {
              xData.push(item.x)
              yData.push(item.y)
            }
            this.chartDataX = xData
            this.chartDataYBar = yData
            this.showType.zhu.is_have = true
            this.xNames = res.data.result.barLinePieData.xName
            this.yNames = res.data.result.barLinePieData.yName
            let myChart = document.getElementById('chartZhu')
            myChart.style.width = '100%'
            setTimeout(() => {
              this.chartZhuOne()
            }, 30)
          }
          // 如果只有饼状图
          if (res.data.result.hasPieChart === 1) {
            let xData = []
            let yData = []
            for (let item of res.data.result.barLinePieData.valueList) {
              xData.push(item.x)
              yData.push({
                value: item.y,
                name: item.x
              })
            }
            this.chartDataX = xData
            this.chartDataYPie = yData
            this.xNamePie = res.data.result.barLinePieData.xName
            this.showType.pie.is_have = true
            let myChart = document.getElementById('chartPie')
            myChart.style.width = '100%'
            setTimeout(() => {
              this.chartPieOne()
            }, 30)
          }
          // 如果只有折线图
          if (res.data.result.hasLineChart === 1) {
            let xData = []
            let yData = []
            for (let item of res.data.result.barLinePieData.valueList) {
              xData.push(item.x)
              yData.push(item.y)
            }
            this.chartDataX = xData
            this.chartDataY = yData
            this.showType.line.is_have = true
            this.xNames = res.data.result.barLinePieData.xName
            this.yNames = res.data.result.barLinePieData.yName
            let myChart = document.getElementById('chartLine')
            myChart.style.width = '100%'
            setTimeout(() => {
              this.chartLineOne()
            }, 30)
          }
        }
      })
    },
    // 获取可用菜单按钮列表
    getButtonsList () {
      let params = {
        systemCode: 'ZY_INTELLIQUOR',
        authKey: Lockr.get('authKey'),
        sessionId: Lockr.get('sessionId'),
        menuId: getMenId(this.$route.path)
      }
      butonsList(params).then(res => {
        if (res.data.code === '200') {
          let result = res.data.result || []
          let arrObj = Object.keys(this.butsObj)
          let newarr = result.map((item) => {
            return item.perms
          })
          arrObj.map(it => {
            if (newarr.indexOf(it) !== -1) {
              this.butsObj[it] = true
            } else {
              this.butsObj[it] = false
            }
          })
        }
      }).catch(err => {
        this.$message.error(err)
      })
    }
  },
  mounted () {
    this.$nextTick(() => {
      this.showType.zhu.choosed = false
      this.showType.line.choosed = false
      this.showType.pie.choosed = false
      this.showType.table.choosed = false
    })
    this.getButtonsList()
  },
  created () {
    this.loadCusTypes()
    this.showType.zhu.choosed = true
    this.showType.line.choosed = true
    this.showType.pie.choosed = true
    this.showType.table.choosed = true
    this.editId = this.$route.query.id
    this.editSingleNameShow = this.$route.query.name
    this.editSingleName = this.$route.query.name
  }
}
</script>

<style scoped>
.analyse-search-icon {
  display: inline-block;
  color: #1980ff;
  transform: transLateY(2px);
  margin-left: 5px;
}
/*显示复杂查询区域*/
.analyse-search-show .big-terms-content {
  position: relative;
}
.analyse-search-show .big-switch-line {
  width: calc(10% - 1px);
  height: calc(100% - 80px);
  position: absolute;
  left: 7.5%;
  top: 20px;
  border-top: 1px solid #e5e5e5;
  border-bottom: 1px solid #e5e5e5;
  border-left: 1px solid #e5e5e5;
}
.analyse-search-show .big-switch-contents {
  width: 15%;
  position: absolute;
  height: 40px;
  top: calc(50% - 15px);
  margin-top: -20px;
  float: left;
}
.analyse-search-show .big-term-content {
  width: 85%;
  margin-left: 15%;
}
.table-title {
  text-align: left;
}
.dialog-content {
  height: 200px;
}
.content-one span {
  display: inline-block;
  float: left;
  line-height: 20px;
  font-size: 16px;
  margin-top: 10px;
}
.content-one p {
  text-align: left;
}
.big-term-content .aud-first-attr {
  margin-right: 10px;
}
.search-show-termsGroup {
  margin-left: 10px;
}
.analyse-edit-name-btn {
  margin-top: 12px;
  margin-left: 10px;
}
/* 设置图标 */
.setting-btn-quota {
  width: 20px;
  height: 20px;
  float: right;
  margin: 10px 0 0 4px;
  cursor: pointer;
}
.setting-btn-quota img {
  width: 100%;
  height: 100%;
  display: block;
}
</style>
